import React from "react";
import styled from "styled-components";
import { FiBookOpen, FiCalendar, FiAward } from "react-icons/fi";

const Card = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.card || "#171721"};
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 28px 26px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
  transition: all 0.35s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: rgba(133, 76, 230, 0.55);
    transform: translateY(-4px);
    box-shadow: 0 12px 36px rgba(133, 76, 230, 0.18);
  }

  @media (max-width: 640px) {
    padding: 20px 16px;
    gap: 14px;
  }
`;

const CardTop = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
`;

const SchoolLogoWrapper = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 640px) {
    width: 44px;
    height: 44px;
  }
`;

const HeaderDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;
`;

const SchoolName = styled.h3`
  font-size: 19px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.01em;

  @media (max-width: 640px) {
    font-size: 16.5px;
  }
`;

const DegreeName = styled.div`
  font-size: 14.5px;
  font-weight: 600;
  color: #c084fc;
  display: flex;
  align-items: center;
  gap: 6px;

  @media (max-width: 640px) {
    font-size: 13px;
  }
`;

const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 2px;
`;

const DateBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);

  svg {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.45);
  }
`;

const GradeBadge = styled.span`
  background: rgba(133, 76, 230, 0.15);
  border: 1px solid rgba(133, 76, 230, 0.4);
  color: #e879f9;
  font-size: 11.5px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const Description = styled.p`
  font-size: 14.5px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.72);
  margin: 0;

  @media (max-width: 640px) {
    font-size: 13.5px;
  }
`;

const EducationCard = ({ education }) => {
  return (
    <Card className="spotlight-card">
      <CardTop>
        <SchoolLogoWrapper>
          <img
            src={education.img}
            alt={education.school}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </SchoolLogoWrapper>

        <HeaderDetails>
          <SchoolName>{education.school}</SchoolName>
          <DegreeName>
            <FiAward /> {education.degree}
          </DegreeName>
          <MetaRow>
            <DateBadge>
              <FiCalendar /> {education.date}
            </DateBadge>
            {education.grade && (
              <GradeBadge>
                <FiBookOpen /> Grade: {education.grade}
              </GradeBadge>
            )}
          </MetaRow>
        </HeaderDetails>
      </CardTop>

      {education.desc && <Description>{education.desc}</Description>}
    </Card>
  );
};

export default EducationCard;